import axios from "axios";
import axiosRetry from 'axios-retry';

const client = axios.create();
axiosRetry(client, 
  { 
    retries: 3, 
    retryDelay: (retryCount) => {
      // retrydelay 2,4,8 seconds
      return (2**retryCount) * 1000;
    },
    // retry for network error or error status code with 500~599
    // NFR-5227 status 0の場合もretryするようにする。
    retryCondition: (error) => {
      return axiosRetry.isNetworkError(error) || axiosRetry.isRetryableError(error) || (error.response && error.response.status === 0)
    },
  }
);

export default client